<button mat-raised-button
    matTooltip="By default, I delay"
    aria-label="Button that displays a tooltip that has custom delays through a default config"
>
    Button with delay-default tooltip
</button>